// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: tour.proto

/* eslint-disable */
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "usertracking.v3";

export interface Tour {
  is_first_purchase: boolean;
  number_of_prev_orders: number;
  origin_city: string;
  destination_city: string;
  departure_date: Date | undefined;
  arrival_date: Date | undefined;
  return_departure_date: Date | undefined;
  return_arrival_date: Date | undefined;
  search_source: string;
  number_of_passengers: number;
  number_of_rooms: number;
  calendar_type: string;
  search_window: number;
  number_of_results: number;
  select_solution_source: string;
  hotel_id: number;
  outbound_flight_airline: string;
  inbound_flight_airline: string;
  total_price: number;
  tour_provider: string;
  tour_position_rank: number;
  flight_room_position_rank: number;
  tour_sorting_option: string;
  flight_room_sorting_option: string;
  tour_has_filters: boolean;
  flight_room_has_filters: boolean;
  hotel_stars: number;
  hotel_details_tab: string;
  number_of_adults: number;
  number_of_children: number;
  tracking_code: string;
  user_discount: number;
  final_price: number;
  payment_gateway: string;
  error_message: string;
  thankyou_page_status: string;
  voucher_language: string;
  eligible_payment_gateways: string[];
  step: string;
  gateway: string;
  hotel_name: string;
  nights: number;
  price_difference: number;
  days_away: number;
  room_type: string[];
  basket_price: number;
  ycard_balance: number;
  penny_balance: number;
  badge_type: string;
  current_results_count: number;
}

function createBaseTour(): Tour {
  return {
    is_first_purchase: false,
    number_of_prev_orders: 0,
    origin_city: "",
    destination_city: "",
    departure_date: undefined,
    arrival_date: undefined,
    return_departure_date: undefined,
    return_arrival_date: undefined,
    search_source: "",
    number_of_passengers: 0,
    number_of_rooms: 0,
    calendar_type: "",
    search_window: 0,
    number_of_results: 0,
    select_solution_source: "",
    hotel_id: 0,
    outbound_flight_airline: "",
    inbound_flight_airline: "",
    total_price: 0,
    tour_provider: "",
    tour_position_rank: 0,
    flight_room_position_rank: 0,
    tour_sorting_option: "",
    flight_room_sorting_option: "",
    tour_has_filters: false,
    flight_room_has_filters: false,
    hotel_stars: 0,
    hotel_details_tab: "",
    number_of_adults: 0,
    number_of_children: 0,
    tracking_code: "",
    user_discount: 0,
    final_price: 0,
    payment_gateway: "",
    error_message: "",
    thankyou_page_status: "",
    voucher_language: "",
    eligible_payment_gateways: [],
    step: "",
    gateway: "",
    hotel_name: "",
    nights: 0,
    price_difference: 0,
    days_away: 0,
    room_type: [],
    basket_price: 0,
    ycard_balance: 0,
    penny_balance: 0,
    badge_type: "",
    current_results_count: 0
  };
}

export const Tour: MessageFns<Tour> = {
  fromJSON(object: any): Tour {
    return {
      is_first_purchase: isSet(object.is_first_purchase) ? globalThis.Boolean(object.is_first_purchase) : false,
      number_of_prev_orders: isSet(object.number_of_prev_orders) ? globalThis.Number(object.number_of_prev_orders) : 0,
      origin_city: isSet(object.origin_city) ? globalThis.String(object.origin_city) : "",
      destination_city: isSet(object.destination_city) ? globalThis.String(object.destination_city) : "",
      departure_date: isSet(object.departure_date) ? fromJsonTimestamp(object.departure_date) : undefined,
      arrival_date: isSet(object.arrival_date) ? fromJsonTimestamp(object.arrival_date) : undefined,
      return_departure_date: isSet(object.return_departure_date)
        ? fromJsonTimestamp(object.return_departure_date)
        : undefined,
      return_arrival_date: isSet(object.return_arrival_date)
        ? fromJsonTimestamp(object.return_arrival_date)
        : undefined,
      search_source: isSet(object.search_source) ? globalThis.String(object.search_source) : "",
      number_of_passengers: isSet(object.number_of_passengers) ? globalThis.Number(object.number_of_passengers) : 0,
      number_of_rooms: isSet(object.number_of_rooms) ? globalThis.Number(object.number_of_rooms) : 0,
      calendar_type: isSet(object.calendar_type) ? globalThis.String(object.calendar_type) : "",
      search_window: isSet(object.search_window) ? globalThis.Number(object.search_window) : 0,
      number_of_results: isSet(object.number_of_results) ? globalThis.Number(object.number_of_results) : 0,
      select_solution_source: isSet(object.select_solution_source)
        ? globalThis.String(object.select_solution_source)
        : "",
      hotel_id: isSet(object.hotel_id) ? globalThis.Number(object.hotel_id) : 0,
      outbound_flight_airline: isSet(object.outbound_flight_airline)
        ? globalThis.String(object.outbound_flight_airline)
        : "",
      inbound_flight_airline: isSet(object.inbound_flight_airline)
        ? globalThis.String(object.inbound_flight_airline)
        : "",
      total_price: isSet(object.total_price) ? globalThis.Number(object.total_price) : 0,
      tour_provider: isSet(object.tour_provider) ? globalThis.String(object.tour_provider) : "",
      tour_position_rank: isSet(object.tour_position_rank) ? globalThis.Number(object.tour_position_rank) : 0,
      flight_room_position_rank: isSet(object.flight_room_position_rank)
        ? globalThis.Number(object.flight_room_position_rank)
        : 0,
      tour_sorting_option: isSet(object.tour_sorting_option) ? globalThis.String(object.tour_sorting_option) : "",
      flight_room_sorting_option: isSet(object.flight_room_sorting_option)
        ? globalThis.String(object.flight_room_sorting_option)
        : "",
      tour_has_filters: isSet(object.tour_has_filters) ? globalThis.Boolean(object.tour_has_filters) : false,
      flight_room_has_filters: isSet(object.flight_room_has_filters)
        ? globalThis.Boolean(object.flight_room_has_filters)
        : false,
      hotel_stars: isSet(object.hotel_stars) ? globalThis.Number(object.hotel_stars) : 0,
      hotel_details_tab: isSet(object.hotel_details_tab) ? globalThis.String(object.hotel_details_tab) : "",
      number_of_adults: isSet(object.number_of_adults) ? globalThis.Number(object.number_of_adults) : 0,
      number_of_children: isSet(object.number_of_children) ? globalThis.Number(object.number_of_children) : 0,
      tracking_code: isSet(object.tracking_code) ? globalThis.String(object.tracking_code) : "",
      user_discount: isSet(object.user_discount) ? globalThis.Number(object.user_discount) : 0,
      final_price: isSet(object.final_price) ? globalThis.Number(object.final_price) : 0,
      payment_gateway: isSet(object.payment_gateway) ? globalThis.String(object.payment_gateway) : "",
      error_message: isSet(object.error_message) ? globalThis.String(object.error_message) : "",
      thankyou_page_status: isSet(object.thankyou_page_status) ? globalThis.String(object.thankyou_page_status) : "",
      voucher_language: isSet(object.voucher_language) ? globalThis.String(object.voucher_language) : "",
      eligible_payment_gateways: globalThis.Array.isArray(object?.eligible_payment_gateways)
        ? object.eligible_payment_gateways.map((e: any) => globalThis.String(e))
        : [],
      step: isSet(object.step) ? globalThis.String(object.step) : "",
      gateway: isSet(object.gateway) ? globalThis.String(object.gateway) : "",
      hotel_name: isSet(object.hotel_name) ? globalThis.String(object.hotel_name) : "",
      nights: isSet(object.nights) ? globalThis.Number(object.nights) : 0,
      price_difference: isSet(object.price_difference) ? globalThis.Number(object.price_difference) : 0,
      days_away: isSet(object.days_away) ? globalThis.Number(object.days_away) : 0,
      room_type: globalThis.Array.isArray(object?.room_type)
        ? object.room_type.map((e: any) => globalThis.String(e))
        : [],
      basket_price: isSet(object.basket_price) ? globalThis.Number(object.basket_price) : 0,
      ycard_balance: isSet(object.ycard_balance) ? globalThis.Number(object.ycard_balance) : 0,
      penny_balance: isSet(object.penny_balance) ? globalThis.Number(object.penny_balance) : 0,
      badge_type: isSet(object.badge_type) ? globalThis.String(object.badge_type) : "",
      current_results_count: isSet(object.current_results_count) ? globalThis.Number(object.current_results_count) : 0,
    };
  },

  toJSON(message: Tour): unknown {
    const obj: any = {};
    if (message.is_first_purchase !== false) {
      obj.is_first_purchase = message.is_first_purchase;
    }
    if (message.number_of_prev_orders !== 0) {
      obj.number_of_prev_orders = Math.round(message.number_of_prev_orders);
    }
    if (message.origin_city !== "") {
      obj.origin_city = message.origin_city;
    }
    if (message.destination_city !== "") {
      obj.destination_city = message.destination_city;
    }
    if (message.departure_date !== undefined) {
      obj.departure_date = message.departure_date.toISOString();
    }
    if (message.arrival_date !== undefined) {
      obj.arrival_date = message.arrival_date.toISOString();
    }
    if (message.return_departure_date !== undefined) {
      obj.return_departure_date = message.return_departure_date.toISOString();
    }
    if (message.return_arrival_date !== undefined) {
      obj.return_arrival_date = message.return_arrival_date.toISOString();
    }
    if (message.search_source !== "") {
      obj.search_source = message.search_source;
    }
    if (message.number_of_passengers !== 0) {
      obj.number_of_passengers = Math.round(message.number_of_passengers);
    }
    if (message.number_of_rooms !== 0) {
      obj.number_of_rooms = Math.round(message.number_of_rooms);
    }
    if (message.calendar_type !== "") {
      obj.calendar_type = message.calendar_type;
    }
    if (message.search_window !== 0) {
      obj.search_window = Math.round(message.search_window);
    }
    if (message.number_of_results !== 0) {
      obj.number_of_results = Math.round(message.number_of_results);
    }
    if (message.select_solution_source !== "") {
      obj.select_solution_source = message.select_solution_source;
    }
    if (message.hotel_id !== 0) {
      obj.hotel_id = Math.round(message.hotel_id);
    }
    if (message.outbound_flight_airline !== "") {
      obj.outbound_flight_airline = message.outbound_flight_airline;
    }
    if (message.inbound_flight_airline !== "") {
      obj.inbound_flight_airline = message.inbound_flight_airline;
    }
    if (message.total_price !== 0) {
      obj.total_price = Math.round(message.total_price);
    }
    if (message.tour_provider !== "") {
      obj.tour_provider = message.tour_provider;
    }
    if (message.tour_position_rank !== 0) {
      obj.tour_position_rank = Math.round(message.tour_position_rank);
    }
    if (message.flight_room_position_rank !== 0) {
      obj.flight_room_position_rank = Math.round(message.flight_room_position_rank);
    }
    if (message.tour_sorting_option !== "") {
      obj.tour_sorting_option = message.tour_sorting_option;
    }
    if (message.flight_room_sorting_option !== "") {
      obj.flight_room_sorting_option = message.flight_room_sorting_option;
    }
    if (message.tour_has_filters !== false) {
      obj.tour_has_filters = message.tour_has_filters;
    }
    if (message.flight_room_has_filters !== false) {
      obj.flight_room_has_filters = message.flight_room_has_filters;
    }
    if (message.hotel_stars !== 0) {
      obj.hotel_stars = Math.round(message.hotel_stars);
    }
    if (message.hotel_details_tab !== "") {
      obj.hotel_details_tab = message.hotel_details_tab;
    }
    if (message.number_of_adults !== 0) {
      obj.number_of_adults = Math.round(message.number_of_adults);
    }
    if (message.number_of_children !== 0) {
      obj.number_of_children = Math.round(message.number_of_children);
    }
    if (message.tracking_code !== "") {
      obj.tracking_code = message.tracking_code;
    }
    if (message.user_discount !== 0) {
      obj.user_discount = Math.round(message.user_discount);
    }
    if (message.final_price !== 0) {
      obj.final_price = Math.round(message.final_price);
    }
    if (message.payment_gateway !== "") {
      obj.payment_gateway = message.payment_gateway;
    }
    if (message.error_message !== "") {
      obj.error_message = message.error_message;
    }
    if (message.thankyou_page_status !== "") {
      obj.thankyou_page_status = message.thankyou_page_status;
    }
    if (message.voucher_language !== "") {
      obj.voucher_language = message.voucher_language;
    }
    if (message.eligible_payment_gateways?.length) {
      obj.eligible_payment_gateways = message.eligible_payment_gateways;
    }
    if (message.step !== "") {
      obj.step = message.step;
    }
    if (message.gateway !== "") {
      obj.gateway = message.gateway;
    }
    if (message.hotel_name !== "") {
      obj.hotel_name = message.hotel_name;
    }
    if (message.nights !== 0) {
      obj.nights = Math.round(message.nights);
    }
    if (message.price_difference !== 0) {
      obj.price_difference = Math.round(message.price_difference);
    }
    if (message.days_away !== 0) {
      obj.days_away = Math.round(message.days_away);
    }
    if (message.room_type?.length) {
      obj.room_type = message.room_type;
    }
    if (message.basket_price !== 0) {
      obj.basket_price = Math.round(message.basket_price);
    }
    if (message.ycard_balance !== 0) {
      obj.ycard_balance = Math.round(message.ycard_balance);
    }
    if (message.penny_balance !== 0) {
      obj.penny_balance = Math.round(message.penny_balance);
    }
    if (message.badge_type !== "") {
      obj.badge_type = message.badge_type;
    }
    if (message.current_results_count !== 0) {
      obj.current_results_count = Math.round(message.current_results_count);
    }
    return obj;
  },

  create(base?: DeepPartial<Tour>): Tour {
    return Tour.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Tour>): Tour {
    const message = createBaseTour();
    message.is_first_purchase = object.is_first_purchase ?? false;
    message.number_of_prev_orders = object.number_of_prev_orders ?? 0;
    message.origin_city = object.origin_city ?? "";
    message.destination_city = object.destination_city ?? "";
    message.departure_date = object.departure_date ?? undefined;
    message.arrival_date = object.arrival_date ?? undefined;
    message.return_departure_date = object.return_departure_date ?? undefined;
    message.return_arrival_date = object.return_arrival_date ?? undefined;
    message.search_source = object.search_source ?? "";
    message.number_of_passengers = object.number_of_passengers ?? 0;
    message.number_of_rooms = object.number_of_rooms ?? 0;
    message.calendar_type = object.calendar_type ?? "";
    message.search_window = object.search_window ?? 0;
    message.number_of_results = object.number_of_results ?? 0;
    message.select_solution_source = object.select_solution_source ?? "";
    message.hotel_id = object.hotel_id ?? 0;
    message.outbound_flight_airline = object.outbound_flight_airline ?? "";
    message.inbound_flight_airline = object.inbound_flight_airline ?? "";
    message.total_price = object.total_price ?? 0;
    message.tour_provider = object.tour_provider ?? "";
    message.tour_position_rank = object.tour_position_rank ?? 0;
    message.flight_room_position_rank = object.flight_room_position_rank ?? 0;
    message.tour_sorting_option = object.tour_sorting_option ?? "";
    message.flight_room_sorting_option = object.flight_room_sorting_option ?? "";
    message.tour_has_filters = object.tour_has_filters ?? false;
    message.flight_room_has_filters = object.flight_room_has_filters ?? false;
    message.hotel_stars = object.hotel_stars ?? 0;
    message.hotel_details_tab = object.hotel_details_tab ?? "";
    message.number_of_adults = object.number_of_adults ?? 0;
    message.number_of_children = object.number_of_children ?? 0;
    message.tracking_code = object.tracking_code ?? "";
    message.user_discount = object.user_discount ?? 0;
    message.final_price = object.final_price ?? 0;
    message.payment_gateway = object.payment_gateway ?? "";
    message.error_message = object.error_message ?? "";
    message.thankyou_page_status = object.thankyou_page_status ?? "";
    message.voucher_language = object.voucher_language ?? "";
    message.eligible_payment_gateways = object.eligible_payment_gateways?.map((e) => e) || [];
    message.step = object.step ?? "";
    message.gateway = object.gateway ?? "";
    message.hotel_name = object.hotel_name ?? "";
    message.nights = object.nights ?? 0;
    message.price_difference = object.price_difference ?? 0;
    message.days_away = object.days_away ?? 0;
    message.room_type = object.room_type?.map((e) => e) || [];
    message.basket_price = object.basket_price ?? 0;
    message.ycard_balance = object.ycard_balance ?? 0;
    message.penny_balance = object.penny_balance ?? 0;
    message.badge_type = object.badge_type ?? "";
    message.current_results_count = object.current_results_count ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
